import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES =
  Resources.Pages.Content.Merchants.OrbitLOnboarding.TerminalCountChange;

type Props = {
  isDismissing: boolean;
  onClose: () => void;
  onConfirm: (note: string) => void;
};

export const DismissTerminalCountRequestDialog = ({
  isDismissing,
  onClose,
  onConfirm,
}: Props) => {
  const { t } = useResource();
  const [note, setNote] = useState("");

  const trimmedNote = note.trim();

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t(RESOURCES.DismissDialogTitle)}</DialogTitle>
      <DialogContent>
        <TextField
          label={t(RESOURCES.DismissNoteLabel)}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          error={!trimmedNote}
          helperText={!trimmedNote ? t(RESOURCES.DismissNoteRequired) : ""}
          multiline
          minRows={2}
          fullWidth
          margin="dense"
          slotProps={{ htmlInput: { maxLength: 1000 } }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isDismissing}>
          {t(RESOURCES.Cancel)}
        </Button>
        <Button
          variant="contained"
          color="error"
          disabled={isDismissing || !trimmedNote}
          onClick={() => onConfirm(trimmedNote)}
        >
          {t(RESOURCES.DismissConfirm)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
